import classNames from "classnames";

import RaycastLogoNegIcon from "assets/icons/raycast-logo-neg.svg";
import ArrowRightIcon from "assets/icons/arrow-right.svg";

import UserAvatar from "./UserAvatar";

import styles from "./AddStory.module.css";

const AddStory: React.FC = () => (
  <a href={`/community-stories/add`} className={classNames(styles.story, styles.add)} key={"add"}>
    <UserAvatar alt="Add your story" icon={<RaycastLogoNegIcon className="icon" />} size="small" />
    <div className={styles.details}>
      <div className={styles.name}>Share your experience</div>
      <div className={styles.position}>
        Fill out the template&nbsp;
        <ArrowRightIcon className={classNames("icon", styles.arrowRight)} />
      </div>
    </div>
  </a>
);

export default AddStory;
